<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="720px">
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title class="text-h5">
              <!-- {{ title }} -->
              Add Dealer
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="8" class="mt-0 pt-0">
                    <v-text-field
                      label="Company Name*"
                      v-model="form.companyName"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="4" class="mt-0 pt-0">
                    <v-select
                      :items="dealerTypes"
                      label="Dealer Type*"
                      :rules="rules.required"
                      v-model="form.dealerType"
                    ></v-select>
                  </v-col>

                  <v-col cols="4" class="mt-0 pt-0">
                    <v-text-field
                      label="First Name*"
                      v-model="form.firstName"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="4" class="mt-0 pt-0">
                    <v-text-field
                      label="Middle Name*"
                      v-model="form.middleName"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="4" class="mt-0 pt-0">
                    <v-text-field
                      label="Last Name*"
                      v-model="form.lastName"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Mobile Number*"
                      v-model="form.mobileNumber"
                      v-mask="'+63 ### #### ###'"
                      masked="false"
                      type="tel"
                      placeholder="+63 XXX XXXX XXX"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Email Address*"
                      v-model="form.emailAddress"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      :items="gender"
                      label="Gender*"
                      :rules="rules.required"
                      v-model="form.gender"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      type="date"
                      label="Birthday*"
                      v-model="form.birthdate"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" class="mt-0 pt-0">
                    <v-text-field
                      label="Building No*"
                      v-model="form.bldgNo"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" class="mt-0 pt-0">
                    <v-text-field
                      label="Street No*"
                      v-model="form.street_no"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      :items="location.regions"
                      label="Region"
                      item-text="name"
                      return-object
                      @change="regionSelected($event)"
                      :rules="rules.required"
                      v-model="form.region"
                      :disabled="location.regions < 1"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      :items="location.provinces"
                      label="Province"
                      item-text="name"
                      return-object
                      @change="provinceSelected($event)"
                      :rules="rules.required"
                      v-model="form.province"
                      :disabled="location.provinces < 1"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      :items="location.cities"
                      label="City"
                      item-text="name"
                      return-object
                      @change="citySelected($event)"
                      :rules="rules.required"
                      v-model="form.city"
                      :disabled="location.cities < 1"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      :items="location.barangay"
                      label="Barangay"
                      item-value="name"
                      item-text="name"
                      :rules="rules.required"
                      v-model="form.barangay"
                      :disabled="location.barangay < 1"
                    ></v-select>
                  </v-col>

                  <!-- <v-col cols="12" class="mt-0 pt-0">
                    <v-file-input
                      counter
                      show-size
                      label="Upload File*"
                      truncate-length="15"
                      prepend-icon=""
                      append-icon="mdi-image"
                      accept="image/*"
                      :rules="rules.required"
                      @change="handleImage"
                    ></v-file-input>
                  </v-col> -->
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>

            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn @click.native="cancel">
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click="onSubmit()"
                class="px-10"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-col>
    <Snackbar />
  </v-row>
</template>

<script>
import ShareableMethods from "@/mixins/ShareableMethods";
import Snackbar from "../Snackbar.vue";

export default {
  mixins: [ShareableMethods],
  name: "AddDistributorDialog",
  components: { Snackbar },
  data() {
    return {
      gender: ["MALE", "FEMALE"],
      // dealerTypes: ["Dealer", "Internal Dealer", "Dealer MSA", "Dealer MSP"],
      dealerTypes: ["Dealer"],
      location: {
        regions: [],
        provinces: [],
        cities: [],
        barangay: [],
      },
      exportData: [],
      fileName: "",

      dialog: false,
      resolve: null,
      reject: null,
      // message: null,
      // title: null,
      // options: {
      //   color: "grey lighten-3",
      //   width: 400,
      //   zIndex: 200,
      //   noconfirm: false,
      // },

      rules: {
        required: [(value) => !!value || "Required."],
      },
      form: {
        companyName: "",
        firstName: "",
        lastName: "",
        middleName: "",
        bldgNo: "",
        street_no: "",
        barangay: "",
        city: "",
        province: "",
        region: "",
        emailAddress: "",
        mobileNumber: "",
        gender: "",
        birthdate: "",
        dealerType: "Dealer",
        file: "",
      },
      loadingBtn: false,
    };
  },

  methods: {
    open() {
      this.dialog = true;
      // this.getRetailerSales(data.retailerId);
      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.resolve(true);
      this.dialog = false;
    },

    cancel() {
      this.resolve(false);
      this.dialog = false;
    },

    async onSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      const { adminLogin } = this.userData;
      this.loadingBtn = true;
      let data = this.form;

      data.mobileNumber = this.trimMobileNumber(data.mobileNumber);
      data.createdBy = adminLogin.name;
      data.distributorDealerId = adminLogin.distributorId;
      data.distributorMobileNumber = adminLogin.distributorMobileNumber;

      await this.$drs
        .post("/broker/drs/dealers", data)
        .then((response) => {
          const res = response.data;
          this.$store.dispatch("addSnackbarMessage", res.message);
          this.$store.dispatch("addSnackbar", true);
          this.loadingBtn = false;

          if (res.status) {
            this.$refs.form.reset();
            this.agree();
          }
          // this.$emit("response", true);

          // this.loadingBtn = false;
          // this.$refs.form.reset();
          // this.$store.dispatch(
          //   "addSnackbarMessage",
          //   "IBAS user is successfully added."
          // );
          // this.$store.dispatch("addSnackbar", true);
        })
        .catch((e) => {
          console.log(e);
          this.loadingBtn = false;
        });
    },

    async getLocation(base = "regions", params = "") {
      await this.$location
        .get(`${base}?${params}`)
        .then((response) => {
          const res = response.data.data;
          console.log(res);
          if (base === "regions") {
            this.location.regions = res.regions;
          }
          if (base === "provinces") {
            this.location.provinces = res.provinces;
          }
          if (base === "cities") {
            this.location.cities = res.cities;
          }
          if (base === "barangay") {
            this.location.barangay = res.baranggay;
          }
          // return (res);
        })
        .catch((e) => {
          console.log(e);
          this.loadingBtn = false;
        });
    },

    regionSelected(e) {
      this.getLocation("provinces", `regionId=${e._id}`);
      this.form.region = e.name;
      this.form.province = "";
      this.form.city = "";
      this.form.barangay = "";
    },

    provinceSelected(e) {
      this.getLocation("cities", `provinceId=${e._id}`);
      this.form.province = e.name;
      this.form.city = "";
      this.form.barangay = "";
    },

    citySelected(e) {
      this.getLocation("barangay", `cityId=${e._id}`);
      // this.form.city = ""
      this.form.city = e.name;
      this.form.barangay = "";
    },

    handleImage(value) {
      let fr = new FileReader();
      const self = this;
      fr.addEventListener("load", function(e) {
        //this is your base64

        //console.log(e.target.result);
        self.form.file = e.target.result.split(",")[1];
      });
      fr.readAsDataURL(value);
    },
  },

  created() {
    this.getLocation();
  },

  computed: {
    userData() {
      return this.$store.getters.userData;
    },
  },
};
</script>
